import { Image } from 'react-datocms';
import type { QuestionImageFragment } from '@/utils/dato/generated';

const QuestionImage = ({ image }: QuestionImageFragment) =>
  image?.responsiveImage ? (
    <div className="mt-8 mb-10">
      <figure className="m-0 bg-base-100 sm:rounded-lg">
        <div className="p-4 lg:p-8">
          <Image data={image.responsiveImage} style={{ margin: '0 auto' }} objectPosition="50% 50%" />
        </div>
        {image?.responsiveImage?.title ? (
          <figcaption className="mb-auto bg-base-300 block px-4 py-4 md:py-7 md:px-7 sm:rounded-b-lg">
            <p className="text-lg text-background">{image.responsiveImage.title}</p>
          </figcaption>
        ) : null}
      </figure>
    </div>
  ) : null;

export default QuestionImage;
